<soft-overlay [mode]="'sidebar'"
              [open]="service.opened()"
              (openChange)="$event ? service.opened.set(true) : service.opened.set(false)">
  <div class="flex flex-col gap-4 pt-6 h-full">
    <div class="sidebar-picker">
      <div class="flex items-center justify-between gap-2 px-6">
        <h2 class="ds-title-1-semibold">
          @if (canBack()) {
            <div class="flex flex-row gap-2 hover:cursor-pointer" (click)="back()">
              <soft-icon [name]="'fa-regular fa-arrow-left'" size="sm" />
              <span>{{ title() }}</span>
            </div>
          }
          @else {
            {{ title() }}
          }
        </h2>
        <soft-ds-button mode="iconOnly" variant="ghost" size="sm"
                        [aria-label]="'#CORE_FILTER.CLOSE' | translate"
                        (click)="cancel()"
                        data-testid="page-filter-close">
          <soft-ds-icon name="fa-regular fa-xmark" />
        </soft-ds-button>
      </div>

      @if (templateService && service.view() === 'filter' && tabsVisible()) {
        <div class="px-6 mt-4">
          <button type="button"
                  class="filter-template-trigger"
                  cdkOverlayOrigin
                  #templatesOrigin="cdkOverlayOrigin"
                  [attr.aria-expanded]="templatesOpen()"
                  aria-haspopup="dialog"
                  (click)="templatesOpen.set(!templatesOpen())"
                  data-testid="page-filter-templates-dropdown">
            <span class="ds-body-2 truncate">{{ templateTriggerLabel() }}</span>
            <soft-icon name="fa-regular fa-chevron-down" size="sm" />
          </button>
          <soft-ds-overlay [(open)]="templatesOpen"
                           [originElement]="templatesOrigin"
                           [content]="templatesPanel"
                           [width]="'fit-content'"
                           [dividers]="false"
                           [offset]="4" />
          <ng-template #templatesPanel>
            <div role="dialog" class="filter-template-panel">
              @for (template of templateService.sortedTemplates(); track template.id) {
                <button type="button"
                        class="filter-template-option"
                        (click)="applyTemplate(template)"
                        data-testid="page-filter-template-option">
                  <span class="truncate">{{ template.name }}</span>
                  @if (templateService.displayedActive()?.id === template.id) {
                    <soft-icon name="fa-regular fa-check" size="sm" class="filter-template-check" />
                  }
                </button>
              }
              @empty {
                <span class="ds-caption filter-template-empty">{{ '#CORE_FILTER.TEMPLATES.EMPTY' | translate }}</span>
              }
              <div class="filter-template-divider"></div>
              <button type="button"
                      class="filter-template-option"
                      (click)="openTemplateManagement()"
                      data-testid="page-filter-manage-templates">
                {{ '#CORE_FILTER.TEMPLATES.MANAGE' | translate }}
              </button>
            </div>
          </ng-template>
        </div>
      }

      @if(service.view() === 'filter' && tabsVisible()) {
        <div class="px-6 my-4">
          <soft-ds-tabs [tabs]="viewTabs()"
                        [variant]="'segmented'"
                        [size]="'sm'"
                        [layout]="'fill'"
                        [value]="service.tab()"
                        (valueChange)="$event && service.tab.set($event)">
          </soft-ds-tabs>
        </div>
      }

      <div class="sidebar-filter-scroll">
        @if (service.view() === 'templates') {
          <soft-page-filter-templates></soft-page-filter-templates>
        }
        @else if (service.tab() === 'list') {
          <soft-page-filter-list></soft-page-filter-list>
        } @else if (service.tab() === 'custom') {
          <soft-page-filter-custom></soft-page-filter-custom>
        }
      </div>

      <div class="sidebar-picker-footer">
        <soft-ds-button
          variant="secondary"
          size="sm"
          (click)="reset()"
        >
          {{ '#CORE_FILTER.RESET' | translate }}
        </soft-ds-button>
        <soft-ds-button
          class="ml-auto"
          variant="secondary"
          size="sm"
          (click)="cancel()"
        >
          {{ '#CORE_FILTER.CANCEL' | translate }}
        </soft-ds-button>
        <soft-ds-button
          variant="primary"
          size="sm"
          [disabled]="!canApply()"
          (click)="apply()"
        >
          {{ '#CORE_FILTER.APPLY' | translate }}
        </soft-ds-button>
      </div>
    </div>
  </div>
</soft-overlay>
